import _ from 'lodash';
import $ from 'jquery';
import Backbone from 'backbone';
import {getAppDiscriminator} from "util/AppName"

import './PanelView.css';
import {LocalStorageUtil} from 'util/LocalStorageUtil';
import {invokeLastFunc} from 'util/FuncUtil';
import {getCurrentUserIdLong} from 'module/SessionInfo/api/SessionInfoAPI';
import {appReady} from 'common/appReady';

var sharedEventBus = new Backbone.View();
var $wrapper = $('<div class="PanelViewWrapper" data-role="none"></div>');
$wrapper.hide();
appReady.then(() => {
	$('#PanelViewWrapContent').after($wrapper);
	setTimeout(() => $wrapper.show(), 2);
});

var wrapContentView = new (Backbone.View.extend({
	initialize: function () {
		var that = this;
		this.collection = new Backbone.Collection();
		this.listenTo(this.collection, 'change:open change:fixed change:width', this.refreshMargin);
		appReady.then(() => {
			that.setElement('#PanelViewWrapContent');
		});
	},
	refreshMargin: function () {
		var left = 0;
		var leftPanels = this.collection.where({open: true, fixed: true, position: 'left'});
		var widths = _.map(leftPanels, function (m) {
			return m.get('width');
		});
		if (widths.length) {
			left = _.max(widths);
		}
		const width = left ? `calc(100vw - ${left}px)` : '100vw'
		this.el?.setAttribute('style', `margin-left:${left}px;width:${width}`);
	},
}))();


/**
 * #PanelViewWrapContent => div on page that wraps all content, that is moved by fixed panels
 */
var PanelView = Backbone.View.extend({
	className: "PanelView",
	events: {
		'click .PanelFixateButton': 'togglePanelFixed',
	},
	/**
	 * @param options
	 * @param {String} options.name Panel name, unique per application - used for persisting state
	 * @param {Backbone.View} options.view self rendering view. defines content gets triggered with events from panel
	 * @param {jQuery} options.$togglePanel toggle switch for the popup
	 * @param {boolean} options.pinnable=true
	 */
	initialize: function ({name, view, $togglePanel, pinnable = true}) {
		_.bindAll(this, _.functionsIn(this));
		this.status = new Backbone.Model({
			open: false, fixed: pinnable, pinnable, width: 270, position: 'left',
		});
		wrapContentView.collection.add(this.status);
		this.refreshCss();
		this.name = name;
		this.view = view;
		this.$togglePanel = $togglePanel;
		this.mountToggleButtonHandler(this.$togglePanel);

		this.listenTo(sharedEventBus, 'close', this.sharedEventBusCloseHandler);
		this.listenTo(this.status, 'change:open', this.triggerOpenStateOnChildView);
		this.listenTo(this.status, 'change:open change:fixed change:width', this.evtOpenFixed);
		this.listenTo(this.status, 'change:fixed', this.refreshFixateButton);
		this.refreshFixateButton();

		this.loadSettings();
		if (!pinnable) this.status.set({fixed: false});
		this.listenTo(this.status, 'change', invokeLastFunc(this, 'saveSettings', 200));

		$wrapper.append(this.render().el);
	},
	saveSettings: function () {
		if (!this.name) return;
		LocalStorageUtil.save(this.getStorageName(), this.status.pick('open', 'fixed', 'width', 'position'));
	},
	loadSettings: function () {
		if (!this.name) return;
		this.status.set(LocalStorageUtil.load(this.getStorageName()));
	},
	getStorageName: function () {
		return [
			getCurrentUserIdLong(),
			getAppDiscriminator(),
			'PanelView',
			this.name,
		].join('_');
	},
	mountToggleButtonHandler: function ($togglePanel) {
		if ($togglePanel) $togglePanel.on('click', this.toggleOpen);
	},
	triggerOpenStateOnChildView: function () {
		var open = this.status.get('open');
		this.view.trigger('PanelView:' + (open ? 'open' : 'close'));
	}, // ****************************
	// **** View Event Handler ****
	// ****************************
	open: function () {
		this.status.set({open: true});
	},
	close: function () {
		this.status.set({open: false});
	},
	toggleOpen: function () {
		this.status.set({open: !this.status.get('open')});
	},
	togglePanelFixed: function () {
		const {pinnable, fixed} = this.status.attributes;
		this.status.set({fixed: pinnable && !fixed});
	}, // *****************************
	// **** Model Event Handler ****
	// *****************************
	evtOpenFixed: function () {
		this.refreshCss();
		this.mountGlobalEventHandler();
	},
	refreshFixateButton: function () {
		var fixed = this.status.get('fixed');
		this.$el.toggleClass('fixed', fixed).toggleClass('overlay', !fixed);
	},
	refreshCss: function () {
		//close others first
		//only trigger events for view, open logic is in evtShowHide
		var open = this.status.get('open');
		var fixed = this.status.get('fixed');
		var panelWidth = this.status.get('width');
		this.$el.css({width: panelWidth});
		if (open) {
			sharedEventBus.trigger('close', this, this.status.get('position'));
			this.$el.css({
				marginLeft: 0,
			});
		} else {
			this.$el.css({
				marginLeft: -panelWidth - 20,
			});
		}
	},
	mountGlobalEventHandler: function () {
		var open = this.status.get('open');
		var fixed = this.status.get('fixed');
		if (open && !fixed) this.bindGlobalHandler(true, this.closeOnBlurCbEventNames, this.closeOnBlurCb); else this.bindGlobalHandler(false, this.closeOnBlurCbEventNames, this.closeOnBlurCb);

	}, // ********************************
	// **** Ext Listener Callbacks ****
	// ********************************
	sharedEventBusCloseHandler: function (requester, pos) {
		if (this === requester) return;
		if (this.status.get('position') === pos) this.status.set({open: false});
	}, /////////////// global ////////////////
	closeOnBlurCbEventNames: "click",
	closeOnBlurCb: function (evt) {
		var $target = $(evt.target);
		var clickInPanel = $target.closest(this.el).length;
		var clickOnButton = _.some(this.$togglePanel, function (button) {
			return $target.closest(button).length
		});
		if (!clickInPanel && !clickOnButton) this.status.set({open: false});
	},
	bindGlobalHandler: function (state, event, cb) { //repeatable
		$(document).off(event, null, cb);
		if (state) {
			$(document).on(event, null, cb);
		}
	}, // ************************
	// ******** Render ********
	// ************************
	template: _.template('<div class="PanelHeader unselectableText">\n\t<% if(pinnable) { %>\n\t<div class="PanelFixateButton" title="Fixieren">\n\t\t<i class="fa fa-thumb-tack"></i>\n\t</div>\n\t<% } %>\n</div>\n<div class="PanelContent">\n</div>\n'),
	render: function () {
		this.$el.html(this.template(this.status.attributes));
		this.$el.find('.PanelContent').html(this.view.el);
		return this;
	},
});

export default PanelView;

//var allPanelViews = {};
//
//return {
//	getPanel: function (options) {
//		if (!allPanelViews[options.name]) {
//			allPanelViews[options.name] = new PanelView(options);
//		}
//		return allPanelViews[options.name];
//	}
//};